import { ActionIcon } from "@mantine/core";
import { Archive, Image as ImageIcon, Layers, Type } from "lucide-react";
import type { ReactNode } from "react";

import { Soon } from "../../../ui/Soon";

export interface ComposerToolsProps {
  /** Live's "Products": the product picker, when the catalog offers a change; else Coming soon. */
  products: ReactNode | undefined;
  /** Live's "Reference images": the library image a change starts from; else Coming soon. */
  references: ReactNode | undefined;
  /** Live's "Prompt templates" (G12): the simple composer's panel; else Coming soon. */
  templates: ReactNode | undefined;
  /** Live's "Layerize image" (G13), where the team may use its row; else Coming soon. */
  layerize?: ReactNode | undefined;
}

/**
 * The four tools at the left of the footer, with live's names: products, reference images,
 * prompt templates, layerize image. The first two choose the image a change starts from, when
 * the catalog offers that change (G1 decisions 21 and 22); the third applies a template (G12);
 * the fourth opens live's Layerize mode where the team may use its row (G13).
 */
export function ComposerTools({ products, references, templates, layerize }: ComposerToolsProps) {
  const soon = (label: string, icon: ReactNode) => (
    <Soon>
      {(soonProps) => (
        <ActionIcon {...soonProps} variant="subtle" size={36} aria-label={label}>
          {icon}
        </ActionIcon>
      )}
    </Soon>
  );
  return (
    <>
      {products ?? soon("Products", <Archive size={20} strokeWidth={1.5} />)}
      {references ?? soon("Reference images", <ImageIcon size={20} strokeWidth={1.5} />)}
      {templates ?? soon("Prompt templates", <Type size={20} strokeWidth={1.5} />)}
      {layerize ?? soon("Layerize image", <Layers size={20} strokeWidth={1.5} />)}
    </>
  );
}
